module.exports = __webpack_public_path__ + "media/images/icon_login-38dabb7864635fa074d08d2200844cff.svg";